(() => {
  if (customElements.get('deeplay-trust-assurances')) return;

  class DeeplayTrustAssurances extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.activeModal = null;
      this.activeTrigger = null;
      this.previousBodyOverflow = '';
      this.handleClick = this.handleClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.addEventListener('click', this.handleClick);
      document.addEventListener('keydown', this.handleKeydown);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      document.removeEventListener('keydown', this.handleKeydown);
      if (this.activeModal) this.closeModal(false);
    }

    handleClick(event) {
      const opener = event.target.closest('[data-dp-modal-open]');
      if (opener && this.contains(opener)) {
        const modal = document.getElementById(opener.dataset.dpModalOpen);
        if (modal && this.contains(modal)) this.openModal(modal, opener);
        return;
      }

      if (!this.activeModal) return;
      const closeButton = event.target.closest('[data-dp-modal-close]');
      if (closeButton || event.target === this.activeModal) this.closeModal();
    }

    handleKeydown(event) {
      if (!this.activeModal) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        this.closeModal();
        return;
      }

      if (event.key !== 'Tab') return;
      const focusable = Array.from(
        this.activeModal.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      ).filter((element) => element.offsetParent !== null);

      if (!focusable.length) {
        event.preventDefault();
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    openModal(modal, trigger) {
      if (this.activeModal && this.activeModal !== modal) this.closeModal(false);
      this.activeModal = modal;
      this.activeTrigger = trigger;
      this.previousBodyOverflow = document.body.style.overflow;
      modal.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(() => modal.querySelector('[data-dp-modal-close]')?.focus());
    }

    closeModal(restoreFocus = true) {
      if (!this.activeModal) return;
      const modal = this.activeModal;
      const trigger = this.activeTrigger;
      modal.hidden = true;
      trigger?.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = this.previousBodyOverflow;
      this.activeModal = null;
      this.activeTrigger = null;
      if (restoreFocus) trigger?.focus();
    }
  }

  customElements.define('deeplay-trust-assurances', DeeplayTrustAssurances);
})();